if (typeof homeCarrusel !== 'function') {
    class homeCarrusel extends HTMLElement {
        constructor() {
            super();
            this.slickGallery = this.querySelector('[data-adrnl-slider]');
            this.waitForSlick();            
        }

        waitForSlick() {
            const checkSlick = setInterval(() => {
                if (window.jQuery && typeof jQuery.fn.slick !== 'undefined') {
                    clearInterval(checkSlick);
                    this.initSlick();
                }
            }, 100);
        }

        initSlick() {
            if (!this.slickGallery) return;
            
            jQuery(this.slickGallery).slick({
                dots: true,
                arrows: false,
                fade: true,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 400,
                autoplay: true,
                autoplaySpeed: 4000,
            });
        }
    }
    if (typeof customElements.get('adrnl-slider') === 'undefined') {
        customElements.define('adrnl-slider', homeCarrusel);
    }
}